// extracted by mini-css-extract-plugin
module.exports = {"container":"_5a28450529--container--mEqjJ","container-phone":"_5a28450529--container-phone--QSZKY","title":"_5a28450529--title--PRHoo","list":"_5a28450529--list--l6eET"};